module.exports = __webpack_public_path__ + "img/signal-03.089c5fef.svg";